import {styled} from "@mui/material";
import MuiAccordion, {AccordionProps} from "@mui/material/Accordion";
import MuiAccordionSummary, {AccordionSummaryProps} from "@mui/material/AccordionSummary";
import LinearProgress, {linearProgressClasses} from "@mui/material/LinearProgress";
import MuiAccordionDetails from "@mui/material/AccordionDetails";
import React from "react";

export const Accordion = styled(
    (props: AccordionProps) => (<MuiAccordion disableGutters elevation={0} square {...props} />)
    // forwardRef((props:AccordionProps, ref) => {
    //     return <MuiAccordion disableGutters elevation={0} square {...props} ref={ref}/>;
    // })
)(({theme}) => ({
    margin: 0,
    ':before': {
        opacity: "1!important"
    },
    '@media (min-width: 768px)': {
        width: '100%',
    },
}));

export const AccordionSummary = styled(
    (props: AccordionSummaryProps) => {
        return <MuiAccordionSummary {...props}/>
    }
)(({theme}) => ({
    [theme.breakpoints.down("md")]: {
        '& .MuiAccordionSummary-expandIconWrapper': {
            marginTop: "auto",
            paddingLeft: "10px"
        },
        '& .Mui-expanded': {
            paddingLeft: 0,
            paddingRight: "5px"
        }
    },
    padding: "20px",
    width: "100%",
    margin: 0,
    '& .MuiAccordionSummary-content': {
        display: "inline-block",
        width: "100%",
        margin: "0",
        overflow: "auto"
    }
}));

export const BorderLinearProgress = styled(LinearProgress)(({theme}) => ({
    height: 6,
    borderRadius: 3,
    [`&.${linearProgressClasses.colorPrimary}`]: {
        backgroundColor: '#FFFFFF',
    },
    [`& .${linearProgressClasses.bar}`]: {
        backgroundColor: '#FD3300',
        borderRadius: 3,
    }
}));

export const BorderLinearProgressHeight6 = styled(LinearProgress)(({theme}) => ({
    height: 6,
    borderRadius: 3,
    [`&.${linearProgressClasses.colorPrimary}`]: {
        backgroundColor: '#FFFFFF',
    },
    [`& .${linearProgressClasses.bar}`]: {
        backgroundColor: '#FD3300',
        borderRadius: 3,
    }
}));

export const AccordionDetails = styled(MuiAccordionDetails)(({theme}) => ({
    padding: 0,
}));